import _get from 'lodash/get';


export const getState = state => state.socialNetworksSettings;

const getAttachedSocialNetworks = state => getState(state).attachedSocialNetworks;
export const getGoogleDataId = state => _get(getAttachedSocialNetworks(state), 'google');
export const getTwitterId = state => _get(getAttachedSocialNetworks(state), 'twitter');
